import { render, staticRenderFns } from "./catalog.vue?vue&type=template&id=188caaaf&scoped=true&"
import script from "./catalog.vue?vue&type=script&lang=ts&"
export * from "./catalog.vue?vue&type=script&lang=ts&"
import style0 from "./catalog.vue?vue&type=style&index=0&id=188caaaf&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188caaaf",
  null
  
)

export default component.exports